import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentMonitorService {
  constructor(private http: HttpClient) {}

  searchEnvironmentMonitor(request: any): Observable<any> {
    console.log(request);
    const url = `${environment.logisticsApiUrl}/sensorReadings/searchSensorReadings`;
    return this.http.post<any>(url, request);
  }

  getSensorFloorOptions(req: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/sensorReadings/getSensorFloorOptions`;
    return this.http.post(url, req);
  }

  getSensorAreaOptions(req: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/sensorReadings/getSensorAreaOptions`;
    return this.http.post(url, req);
  }
}
